export const SITE_URL = 'https://unixtime2.web.app'
export const SITE_TITLE = 'unixtime2datetime'
export const SITE_DESCRIPTION = 'simple unix timestamp to datetime converter'
export const SITE_KEYWORDS = 'unixtime,tool,converter,simple,pwa,offline'
